export default __webpack_public_path__ + "static/media/settings.48ec7abd.svg";